// extracted by mini-css-extract-plugin
export default {"close_container":"styles_close_container__8Zgr6"};